interface ToolListing {
  listTools(): { name: string }[]
}

const getTesting = (): ToolListing | null =>
  (navigator as unknown as { modelContextTesting?: ToolListing }).modelContextTesting ?? null

/**
 * Resolve once a WebMCP tool named `name` is registered (a page-scoped form has
 * mounted and registered its tools), or after `timeoutMs`. Lets a navigation
 * tool wait for the target screen's tools before the agent re-lists, so the
 * agent does not call a form's fill tools before the form exists.
 */
export const waitForToolRegistered = (name: string, timeoutMs = 4000): Promise<boolean> =>
  new Promise((resolve) => {
    const testing = getTesting()
    if (!testing) {
      resolve(false)
      return
    }
    const start = Date.now()
    const tick = () => {
      if (testing.listTools().some((t) => t.name === name)) {
        resolve(true)
        return
      }
      if (Date.now() - start >= timeoutMs) {
        resolve(false)
        return
      }
      setTimeout(tick, 100)
    }
    tick()
  })
